import { required, helpers } from '@vuelidate/validators';
import { computed } from "vue";
import {
    isValidCreditCardNumber,
    isValidCvv,
    isValidExpirationDate,
    isValidHolderName
} from "@/validations/common";

export function getCreditCardRegisterRules(userStore) {
    return computed(() => {
        return {
            card_number: userStore.isCreditCardEdit
                ? {} // Don't validate card number when editing credit card, since the card number is not editable in that case
                : {
                    required: helpers.withMessage('ERROR_CARD_NUMBER_REQUIRED', required),
                    isValidCardNumber: helpers.withMessage('ERROR_CREDITCARD_INVALID', isValidCreditCardNumber),
                },
            expiration_date: {
                required: helpers.withMessage('ERROR_CARD_DATE_REQUIRED', required),
                isValidDate: helpers.withMessage('ERROR_EXPIRATION_DATE_INVALID', isValidExpirationDate),
            },
            holder_name: {
                required: helpers.withMessage('ERROR_CARD_HOLDER_NAME_REQUIRED', required),
                isValidHolderName: helpers.withMessage('ERROR_CARD_HOLDER_INVALID', isValidHolderName),
            },
            cvv: {
                required: helpers.withMessage('ERROR_CARD_CVV_REQUIRED', required),
                isValidCvv: helpers.withMessage('ERROR_CVV_INVALID', isValidCvv),
            },
        }
    })
}